module.exports = require("@openworklabs/filecoin-number");